import { CodePayload } from 'types';
import { baseApi } from './baseApi';

export const barcodeApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createCode: builder.mutation<string, CodePayload>({
      query: (data) => ({
        url: `${process.env.REACT_APP_BASE_URL}/sequences`,
        method: 'POST',
        data,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useCreateCodeMutation } = barcodeApiService;
